/**
 * Form-control `data-hen-id` values that may emit interaction events on
 * focusin/focusout. Must stay aligned with hen-ui `COMPONENT_IDS` (catalog);
 * listed here so eventing does not import the hen-ui root entry (CSS side effects).
 */
export const FOCUS_INTERACTION_COMPONENT_IDS = [
  'hen.input',
  'hen.select',
  'hen.checkbox',
  'hen.checkboxButton',
  'hen.radio',
  'hen.switch',
] as const;
